<template>
    <div v-bind="$attrs" class="wrap-progress-chart" :style="'width:'+divwidth+';'">
        <!--<apex-charts type="bar" :height="height" :width="width" :options="chartOptions" :series="series"></apex-charts>-->
        <div class="progress-char-title" v-html="title"></div>
        <div v-for="(item,index) in results" :key="index" class="wrap-progress-chart-content">
            <div class="progress-title" v-html="' '+(index+1)+'. '+item.x"></div>
            <v-progress-linear
                    :value="item.calc"
                    :color="item.color"
                    height="25"
                    :class="'item-index-'+index"
                    >
                    <template v-slot:default="{ value }">
                        <div class="content-value">
                            <strong v-html="isQuantity?getQuantity(item.y):getPrice(item.y)"></strong>
                        </div>
                    </template>
                    </v-progress-linear>
                    <br>
        </div>
        <slot name="content"></slot>
    </div>
</template>

<script>
import { colors } from '@/Composables/ChartColors';
import { formatIntegerPrice } from '@/Mixins/Formatting';
import { formatQuantity } from '@/Mixins/Formatting';
import { result } from 'lodash';

export default {
    props: {
        options: {
            type: Object,
            default: function () {
                return {};
            },
        },

        height: {
            type: String,
            default: '100%',
        },

        width: {
            type: String,
            default: '100%',
        },
        divwidth: {
            type: String,
            default: '50vw',
        },
        title: {
            type: String,
            default: '',
        },
        isQuantity: {
            type: Boolean,
            default: false,
        },
        alignTitleLeft: {
            type: Boolean,
            default: false,
        },

        subtitle: {
            type: String,
            default: '',
        },

        toolbar: {
            type: Boolean,
            default: false,
        },

        hideLegend: {
            type: Boolean,
            default: false,
        },

        showDataLabels: {
            type: Boolean,
            default: false,
        },

        distributed: {
            type: Boolean,
            default: false,
        },

        isPriceChart: {
            type: Boolean,
            default: false,
        },

        barHeight: {
            type: String,
            default: '70%',
        },

        labels: {
            type: Array,
            default: function () {
                return [];
            },
        },

        maxLabelWidth: {
            type: Number,
            default: 160,
        },

        annotations: {
            type: Array,
            default: function () {
                return [];
            },
        },

        series: {
            type: Array,
            required: true,
        },

        horizontal: {
            type: Boolean,
            default: false,
        },
        offsetX:{
            type: Number,
            default: 0
        },
        isFloat:{
            type: Boolean,
            default: false
        },
    },
    data(){
     return {
        colors:['#154579','#0d8ccd','#9ccfff','#cbe3fa','#e9770f','#ed8d36','#ecaa6e','#f6c79b','#fde9c3','#fde9d4']
     }
    },
    computed: {
       results(){
         //console.log('results',this.series);
         //let max = this.series[0].data[0].y +
         let self=this
         let data=[]
         _.each(this.series[0].data,(o,i)=>{
            //console.log('o',o,i)
             if(i==0){
                o.calc=95
                //o.color=self.colors[i]
             }else{
                 o.calc= data[i-1].calc/(data[i-1].y/o.y)
             }
             o.color=self.colors[i]
             data.push(o)
         })
         return data
         return [{'y':100,x:6000.33},{'y':40,x:5040.33}]
       }
    },
    methods:{
       getPrice(value){
         return this.formatIntegerPrice(value)
       },
       getQuantity(value){
         return this.formatQuantity(value)
       }
    }
};
</script>

<style>
.bar-chart{
  max-width: 768px;
  margin: 5px;
  opacity: 0.9;
}
</style>
